package app.alefly.domain.model

import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
enum class Platform {
    WEB,
    ANDROID,
    IOS,
}

@Serializable
data class ChallengeResult(
    val id: String,
    val challengeId: ChallengeId,
    val clientId: ClientId,
    val displayName: String,
    val score: Int,
    val total: Int,
    val correctCount: Int,
    val hintsUsedCount: Int,
    val durationMs: Long,
    val submittedAt: Instant,
    val platform: Platform,
    val locale: String,
)
